"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4704],{

/***/ 10279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ ToggleDropdownArrow; },
/* harmony export */   "t": function() { return /* binding */ CrossButton; }
/* harmony export */ });
/* harmony import */ var _app_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _search_dropdown_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69280);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var ToggleDropdownArrow = function ToggleDropdownArrow(_ref) {
  var getToggleButtonProps = _ref.getToggleButtonProps,
      isOpen = _ref.isOpen;
  return (
    /* 
        The tabIndex and style are overridden because it takes two tabs for 
        a user to go from one control to another if the button is allowed to
        be tabbable. 
    */
    (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_search_dropdown_style__WEBPACK_IMPORTED_MODULE_2__/* .RightControllerButton */ .Ep, _objectSpread(_objectSpread({}, getToggleButtonProps()), {}, {
      style: {
        outline: 'none'
      },
      tabIndex: "-1",
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_search_dropdown_style__WEBPACK_IMPORTED_MODULE_2__/* .ArrowIcon */ .e0, {
        isOpen: isOpen
      })
    }))
  );
};
var CrossButton = function CrossButton(_ref2) {
  var ariaLabel = _ref2.ariaLabel,
      onClickHandler = _ref2.onClickHandler;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_search_dropdown_style__WEBPACK_IMPORTED_MODULE_2__/* .RightControllerButton */ .Ep, {
    onClick: onClickHandler,
    "aria-label": ariaLabel,
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_search_dropdown_style__WEBPACK_IMPORTED_MODULE_2__/* .XIcon */ .b0, {})
  });
};

/***/ }),

/***/ 67453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ DropdownItem; }
/* harmony export */ });
/* harmony import */ var _app_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94128);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var DropdownItem = function DropdownItem(_ref) {
  var index = _ref.index,
      highlightedIndex = _ref.highlightedIndex,
      getItemProps = _ref.getItemProps,
      item = _ref.item,
      selectedItem = _ref.selectedItem,
      ItemComponent = _ref.ItemComponent;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(ItemComponent, _objectSpread(_objectSpread({
    isActive: highlightedIndex === index
  }, getItemProps({
    item: item,
    index: index,
    isSelected: selectedItem ? selectedItem.key === item.key : false
  })), {}, {
    children: (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .stringifyItem */ .J)(item)
  }));
};

/***/ }),

/***/ 94128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ getFilteredItems; },
/* harmony export */   "J": function() { return /* binding */ stringifyItem; }
/* harmony export */ });
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74194);

var stringifyItem = function stringifyItem(item) {
  return item ? item.title + (item.count ? " (".concat(item.count, ")") : '') : '';
};
var getFilteredItems = function getFilteredItems(filter, items) {
  if (!filter) return items;

  if (!(items !== null && items !== void 0 && items.length)) {
    _utils_logger__WEBPACK_IMPORTED_MODULE_0__/* .log.warn */ .c.warn("Passed items to getFilteredItems is not an array or it's empty");
    return [];
  }

  var filteredItems = items.filter(function (item) {
    return stringifyItem(item).toLowerCase().includes(filter.toLowerCase());
  });
  return filteredItems;
};

/***/ }),

/***/ 90068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ MenuHeaderItems; }
/* harmony export */ });
/* harmony import */ var _app_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94128);
/* harmony import */ var _dropdown_item__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67453);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var MenuHeaderItems = function MenuHeaderItems(_ref) {
  var _getFilteredItems;

  var highlightedIndex = _ref.highlightedIndex,
      getItemProps = _ref.getItemProps,
      allHeadingItem = _ref.allHeadingItem,
      selectedItem = _ref.selectedItem,
      heading = _ref.heading,
      menuItems = _ref.menuItems,
      inputValue = _ref.inputValue,
      ItemComponent = _ref.ItemComponent,
      HeaderItemComponent = _ref.HeaderItemComponent,
      SubHeaderItemComponent = _ref.SubHeaderItemComponent;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .Fragment */ .HY, {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(HeaderItemComponent, _objectSpread(_objectSpread({
      isActive: highlightedIndex === 0
    }, getItemProps({
      item: allHeadingItem,
      isSelected: selectedItem ? selectedItem.key === allHeadingItem.key : false,
      index: 0
    })), {}, {
      children: (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .stringifyItem */ .J)(allHeadingItem)
    })), menuItems !== null && menuItems !== void 0 && menuItems.length ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(SubHeaderItemComponent, {
      children: ["Top ", heading]
    }) : '', menuItems !== null && menuItems !== void 0 && menuItems.length ? ((_getFilteredItems = (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getFilteredItems */ .B)(inputValue, menuItems)) !== null && _getFilteredItems !== void 0 ? _getFilteredItems : []).map(function (item, index) {
      return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_dropdown_item__WEBPACK_IMPORTED_MODULE_3__/* .DropdownItem */ .h, {
        index: index + 1,
        highlightedIndex: highlightedIndex,
        getItemProps: getItemProps,
        item: item,
        selectedItem: selectedItem,
        ItemComponent: ItemComponent
      }, index + 1);
    }) : null, menuItems !== null && menuItems !== void 0 && menuItems.length ? (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(SubHeaderItemComponent, {
      children: ["Alle ", heading]
    }) : null]
  });
};

/***/ }),

/***/ 84704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ mobile_select; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/molecules/search-dropdown/search-dropdown.style.tsx + 2 modules
var search_dropdown_style = __webpack_require__(69280);
// EXTERNAL MODULE: ./src/components/molecules/modal/modal.tsx + 1 modules
var modal = __webpack_require__(52753);
// EXTERNAL MODULE: ./src/components/molecules/search-dropdown/common/helpers.ts
var helpers = __webpack_require__(94128);
// EXTERNAL MODULE: ./src/components/molecules/search-dropdown/common/controller-buttons.tsx
var controller_buttons = __webpack_require__(10279);
// EXTERNAL MODULE: ./node_modules/downshift/dist/downshift.esm.js + 6 modules
var downshift_esm = __webpack_require__(53680);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 3 modules
var emotion_styled_base_browser_esm = __webpack_require__(61516);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./src/components/molecules/search-dropdown/mobile/mobile-select.style.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var OFFSET_FROM_TOP = '180px';
var StyledMobileMenu = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "eg9vfil4"
} : 0)("line-height:2;overflow:auto;max-height:calc(100vh - ", OFFSET_FROM_TOP, ");margin-top:20px;padding:0;" + ( true ? "" : 0));
var StyledMobileItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "eg9vfil3"
} : 0)("cursor:pointer;display:block;list-style:none;padding-left:67px;font-size:16px;line-height:32px;color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";", function (props) {
  return props.isActive ? /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("background:", props.theme.colors['main8'], ";color:", props.theme.shades.white, ";" + ( true ? "" : 0),  true ? "" : 0) : "";
}, " ", function (props) {
  return !props.isActive && props.isSelected ? /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("background:", props.theme.shades.lightGrey, ";" + ( true ? "" : 0),  true ? "" : 0) : "";
}, ";" + ( true ? "" : 0));
var StyledHeaderItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(StyledMobileItem,  true ? {
  target: "eg9vfil2"
} : 0)( true ? {
  name: "1fenxbr",
  styles: "font-weight:700;line-height:40px;border-bottom:1px solid rgba(151, 151, 151, 0.33)"
} : 0);
var StyledSubHeaderItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(StyledMobileItem,  true ? {
  target: "eg9vfil1"
} : 0)( true ? {
  name: "1bm8t9t",
  styles: "font-weight:700;cursor:default"
} : 0);
var StyledMobileInput = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("input",  true ? {
  target: "eg9vfil0"
} : 0)("height:50px;width:100%;box-shadow:", function (props) {
  return props.theme.boxShadow.modalInput;
}, ";border:solid 1px rgba(155, 155, 155, 0.36);padding-left:60px;padding-right:25px;font-size:14px;line-height:1.29;color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ./src/components/molecules/search-dropdown/common/menu-header-items.tsx
var menu_header_items = __webpack_require__(90068);
// EXTERNAL MODULE: ./src/components/molecules/search-dropdown/common/dropdown-item.tsx
var dropdown_item = __webpack_require__(67453);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./src/components/molecules/search-dropdown/mobile/select-box.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var SelectBox = function SelectBox(_ref) {
  var placeholder = _ref.placeholder,
      items = _ref.items,
      onSelectHandler = _ref.onSelectHandler,
      allHeadingItem = _ref.allHeadingItem,
      heading = _ref.heading,
      stateReducer = _ref.stateReducer,
      selectedItem = _ref.selectedItem,
      isModalOpen = _ref.isModalOpen;
  var focusRef = /*#__PURE__*/react.createRef();
  react.useEffect(function () {
    // if (isModalOpen && focusRef.current) {
    //     focusRef.current.focus();
    // }
    if (!isModalOpen && focusRef.current) {
      focusRef.current.blur();
    }
  }, [isModalOpen, focusRef]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(downshift_esm/* default */.ZP, _objectSpread(_objectSpread({
    id: "search autocomplete",
    onSelect: onSelectHandler,
    itemToString: function itemToString(item) {
      if (typeof item === 'string') return item;else if (item === null || item === undefined) return '';
      return (0,helpers/* stringifyItem */.J)(item);
    },
    stateReducer: stateReducer
  }, selectedItem !== undefined && {
    selectedItem: selectedItem
  }), {}, {
    children: function children(_ref2) {
      var getInputProps = _ref2.getInputProps,
          getMenuProps = _ref2.getMenuProps,
          getItemProps = _ref2.getItemProps,
          isOpen = _ref2.isOpen,
          clearSelection = _ref2.clearSelection,
          inputValue = _ref2.inputValue,
          highlightedIndex = _ref2.highlightedIndex,
          selectedItem = _ref2.selectedItem;
      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(search_dropdown_style/* StyledWrapper */.SD, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(search_dropdown_style/* Icon */.JO, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(search_dropdown_style/* SearchIcon */.W1, {})
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledMobileInput, _objectSpread({
            ref: focusRef,
            "aria-label": "select ".concat(heading)
          }, getInputProps({
            isOpen: isOpen,
            placeholder: placeholder
          }))), selectedItem ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(controller_buttons/* CrossButton */.t, {
            onClickHandler: clearSelection,
            ariaLabel: "clear selection"
          }) : null]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledMobileMenu, _objectSpread(_objectSpread({}, getMenuProps()), {}, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [!inputValue && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(menu_header_items/* MenuHeaderItems */.D, {
              highlightedIndex: highlightedIndex,
              getItemProps: getItemProps,
              allHeadingItem: allHeadingItem,
              selectedItem: selectedItem,
              heading: heading,
              menuItems: items.top,
              inputValue: inputValue,
              ItemComponent: StyledMobileItem,
              HeaderItemComponent: StyledHeaderItem,
              SubHeaderItemComponent: StyledSubHeaderItem
            }), (0,helpers/* getFilteredItems */.B)(inputValue, items.all).map(function (item, index) {
              var offsetIndex = index + (!inputValue ? (0,helpers/* getFilteredItems */.B)(inputValue, items.top).length + 1 : 0);
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dropdown_item/* DropdownItem */.h, {
                index: offsetIndex,
                highlightedIndex: highlightedIndex,
                getItemProps: getItemProps,
                item: item,
                selectedItem: selectedItem,
                ItemComponent: StyledMobileItem
              }, offsetIndex);
            })]
          })
        }))]
      });
    }
  }));
};
;// CONCATENATED MODULE: ./src/components/molecules/search-dropdown/mobile/mobile-select.tsx



function mobile_select_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function mobile_select_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? mobile_select_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : mobile_select_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var MobileSelect = function MobileSelect(props) {
  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      isModalOpen = _React$useState2[0],
      setIsModalOpen = _React$useState2[1];

  var _React$useState3 = react.useState(null),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      inputSelectedItem = _React$useState4[0],
      setInputSelectedItem = _React$useState4[1];

  var allHeadingItem = {
    key: '',
    title: props.selectAllText
  };

  var onSelectHandler = function onSelectHandler(selectedItem) {
    if (selectedItem) {
      setIsModalOpen(false);
    } // provides a way for the dropdown to be controlled and uncontrolled


    if (props.selectedItem === undefined) {
      setInputSelectedItem(selectedItem);
    }

    props.onSelectHandler(selectedItem);
  }; // provides a way for the dropdown to be controlled and uncontrolled


  var selectedItem = props.selectedItem === undefined ? inputSelectedItem : props.selectedItem;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(search_dropdown_style/* StyledWrapper */.SD, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(search_dropdown_style/* StyledInput */.Fy, {
        "data-testid": "select-menu-input",
        onClick: function onClick() {
          return setIsModalOpen(true);
        },
        value: selectedItem ? (0,helpers/* stringifyItem */.J)(selectedItem) : props.heading,
        placeholder: props.placeholder,
        style: {
          height: '50px'
        },
        "aria-label": "select ".concat(props.heading),
        readOnly: true,
        "data-testid-value": props.selectedItem ? props.selectedItem.key : null
      }), selectedItem ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(controller_buttons/* CrossButton */.t, {
        onClickHandler: function onClickHandler() {
          setIsModalOpen(true);
          onSelectHandler(null);
        },
        ariaLabel: "clear selection"
      }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(search_dropdown_style/* RightControllerButton */.Ep, {
        "data-testid": "open-menu-btn",
        style: {
          outline: 'none'
        },
        tabIndex: "-1",
        onClick: function onClick() {
          return setIsModalOpen(true);
        },
        "aria-label": "open menu",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(search_dropdown_style/* ArrowIcon */.e0, {})
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(modal/* Modal */.u, {
      showModal: isModalOpen,
      headerText: props.heading,
      onClose: function onClose() {
        return setIsModalOpen(false);
      },
      "data-testid": "".concat(props.category, "-modal"),
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectBox, mobile_select_objectSpread(mobile_select_objectSpread({
        placeholder: selectedItem ? (0,helpers/* stringifyItem */.J)(selectedItem) : props.placeholder,
        items: props.items,
        onSelectHandler: onSelectHandler,
        allHeadingItem: allHeadingItem,
        heading: props.heading,
        selectAllText: props.selectAllText,
        selectedItem: props.selectedItem,
        category: props.category,
        stateReducer: props.stateReducer
      }, props.selectedItem !== undefined && {
        selectedItem: selectedItem
      }), {}, {
        isModalOpen: isModalOpen
      }))
    })]
  });
};

/* harmony default export */ var mobile_select = (MobileSelect);

/***/ })

}]);